'use strict';

var _defineProperty = require("/codebuild/output/src836891638/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _regeneratorRuntime = require("/codebuild/output/src836891638/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/codebuild/output/src836891638/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/codebuild/output/src836891638/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/codebuild/output/src836891638/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/codebuild/output/src836891638/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/codebuild/output/src836891638/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/codebuild/output/src836891638/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _wrapNativeSuper = require("/codebuild/output/src836891638/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapNativeSuper");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var isIp = require('is-ip');

var CancelError = /*#__PURE__*/function (_Error) {
  _inherits(CancelError, _Error);

  var _super = _createSuper(CancelError);

  function CancelError() {
    var _this;

    _classCallCheck(this, CancelError);

    _this = _super.call(this, 'Request was cancelled');
    _this.name = 'CancelError';
    return _this;
  }

  _createClass(CancelError, [{
    key: "isCanceled",
    get: function get() {
      return true;
    }
  }]);

  return CancelError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var defaults = {
  timeout: 5000
};
var urls = {
  v4: ['https://ipv4.icanhazip.com/', 'https://api.ipify.org/'],
  v6: ['https://ipv6.icanhazip.com/', 'https://api6.ipify.org/']
};

var sendXhr = function sendXhr(url, options, version) {
  var xhr = new XMLHttpRequest();

  var _reject;

  var promise = new Promise(function (resolve, reject) {
    _reject = reject;
    xhr.addEventListener('error', reject, {
      once: true
    });
    xhr.addEventListener('timeout', reject, {
      once: true
    });
    xhr.addEventListener('load', function () {
      var ip = xhr.responseText.trim();

      if (!ip || !isIp[version](ip)) {
        reject();
        return;
      }

      resolve(ip);
    }, {
      once: true
    });
    xhr.open('GET', url);
    xhr.timeout = options.timeout;
    xhr.send();
  });

  promise.cancel = function () {
    xhr.abort();

    _reject(new CancelError());
  };

  return promise;
};

var queryHttps = function queryHttps(version, options) {
  var request;

  var promise = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var urls_, _iterator, _step, url, ip;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            urls_ = [].concat.apply(urls[version], options.fallbackUrls || []);
            _iterator = _createForOfIteratorHelper(urls_);
            _context.prev = 2;

            _iterator.s();

          case 4:
            if ((_step = _iterator.n()).done) {
              _context.next = 20;
              break;
            }

            url = _step.value;
            _context.prev = 6;
            request = sendXhr(url, options, version); // eslint-disable-next-line no-await-in-loop

            _context.next = 10;
            return request;

          case 10:
            ip = _context.sent;
            return _context.abrupt("return", ip);

          case 14:
            _context.prev = 14;
            _context.t0 = _context["catch"](6);

            if (!(_context.t0 instanceof CancelError)) {
              _context.next = 18;
              break;
            }

            throw _context.t0;

          case 18:
            _context.next = 4;
            break;

          case 20:
            _context.next = 25;
            break;

          case 22:
            _context.prev = 22;
            _context.t1 = _context["catch"](2);

            _iterator.e(_context.t1);

          case 25:
            _context.prev = 25;

            _iterator.f();

            return _context.finish(25);

          case 28:
            throw new Error('Couldn\'t find your IP');

          case 29:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[2, 22, 25, 28], [6, 14]]);
  }))();

  promise.cancel = function () {
    request.cancel();
  };

  return promise;
};

module.exports.v4 = function (options) {
  return queryHttps('v4', _objectSpread(_objectSpread({}, defaults), options));
};

module.exports.v6 = function (options) {
  return queryHttps('v6', _objectSpread(_objectSpread({}, defaults), options));
};